module.exports = __webpack_public_path__ + "icons_04.dfcafa3d.svg";